import { useMemo } from 'react'

import PageContext from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'
import PageContent from './components/PageContent'

interface RelationsProps {
  providerPriceListId: number,
}
const Relations = (props: RelationsProps) => {
  const { providerPriceListId } = props

  const pageContext = useMemo(() => ({
    callbacks: {
      syncChangesToForks: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <PageContent providerPriceListId={providerPriceListId} />
    </PageContext.Provider>
  )
}

export default Relations
